import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class UnexpectedErrorModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  render() {
    const { onClose } = this.props;
    return (
      <div>
        <p>
          <FormattedMessage id="modal.unexpected-error.text" />
        </p>
        <footer>
          <button onClick={() => onClose(true)}>
            <FormattedMessage id="modal.unexpected-error.approve" />
          </button>
        </footer>
      </div>
    );
  }
}

export default UnexpectedErrorModal;



// WEBPACK FOOTER //
// ./src/modules/modal/unexpected-error-modal.js